__turbopack_context__.v({
  "bottom": "tooltip-module-scss-module__pnA3WW__bottom",
  "left": "tooltip-module-scss-module__pnA3WW__left",
  "neutral": "tooltip-module-scss-module__pnA3WW__neutral",
  "nowrap": "tooltip-module-scss-module__pnA3WW__nowrap",
  "right": "tooltip-module-scss-module__pnA3WW__right",
  "secondary": "tooltip-module-scss-module__pnA3WW__secondary",
  "title": "tooltip-module-scss-module__pnA3WW__title",
  "tooltip": "tooltip-module-scss-module__pnA3WW__tooltip",
  "top": "tooltip-module-scss-module__pnA3WW__top",
});
